// extracted by mini-css-extract-plugin
export default {"user_card":"UserCard_user_card__ue1po","user_link":"UserCard_user_link__QgPt6","user_card_div":"UserCard_user_card_div__hklrb"};